import React from 'react';
import styled, { css } from 'styled-components';
import parse from 'html-react-parser';

import * as Typography from '../Typography';

const HTMLStyles = styled.div`
	a {
		color: ${({ theme }) => theme.colors.black.main};
		text-decoration: underline;
		text-underline-offset: 2px;
		font-family: ${props => props.theme.fonts.body};

		&:hover {
			color: ${({ theme }) => theme.colors.primary.main};
			text-decoration: underline;
		}
	}

	p {
		display: block;
		color: ${({ theme }) => theme.colors.black.main};
		font-family: ${({ theme }) => theme.fonts.body};
		font-weight: 400;
		font-style: normal;
		font-size: 1.6rem;
		line-height: 28px; /* 175% */
		letter-spacing: 0.16px;

		${({ options }) =>
			options?.bodySize === 18 &&
			`font-size: 1.8rem;
			line-height: 32px; /* 177.778% */
			letter-spacing: 0.18px;`}
	}
`;

const standardHtmlStyling = (htmlText, options) => {
	return <HTMLStyles options={options}>{parse(htmlText)}</HTMLStyles>;
};

export default standardHtmlStyling;
